import 'SF/service/Popup.js';
import 'SF/par/ParIframePanel.js';
import 'SF/service/AbstractPanel.js';
import 'SF/service/CatalogDetailProviderPanel.js';
import 'SF/service/CatalogDetailServicePanel.js';
import 'SF/service/CatalogHeaderPanel.js';
import 'SF/service/CatalogPanel.js';
import 'SF/service/EditDescriptionWindow.js';
import 'SF/service/Image.js';
import 'SF/service/InventoryPanel.js';
import 'SF/service/MainPanel.js';
import 'SF/service/MakerPopup.js';
import 'SF/service/PARPanel.js';
import 'SF/service/ProviderListPanel.js';
import 'SF/service/ServiceDetailPanel.js';
import 'SF/service/ServiceListPanel.js';
import 'SF/service/TakerPopup.js';
import 'SF/service/WaitingRoomActionPanel.js';
import 'SF/service/WaitingRoomContentPanel.js';
import 'SF/service/WaitingRoomPanel.js';
import 'SF/service/bundle.js';
import 'SF/service/card/ServiceActionBar.js';
import 'SF/service/card/ServiceCard.js';
import 'SF/service/data/ServiceLoader.js';
import 'SF/service/data/ServiceProviderStore.js';
import 'SF/service/data/ServiceStore.js';
import 'SF/service/data/WaitingRoomAppointmentStore.js';
import 'SF/service/data/WaitingRoomServiceStore.js';
import 'SF/service/data/WaitingRoomStudentStore.js';
import 'SF/service/data/WaitingRoomZombieStore.js';
